(function() {
	'use strict';

	angular
		.module('app.setup')
		.controller('importProjects', importProjects);

	importProjects.$inject = ['$rootScope', '$scope', '$window', '$timeout', 'importProjectsService'];

	function importProjects($rootScope, $scope, $window, $timeout, importProjectsService) {
		var vm = this;
		vm.upload = {};
		vm.allowedUploadType = '.xlsx';
		vm.uploadFile = uploadFile;
		vm.downloadTemplateFile = downloadTemplateFile;
		vm.importResults = [];
		vm.isLeanDNAAdmin = $rootScope.authz.isLeanDNAAdmin();

		function uploadFile() {
			var confirmScope = $scope.$new();
			confirmScope.fileName = vm.upload.file.name;
			vm.showError = false;
			importProjectsService.importProjects(vm.upload).then(function(response){
				vm.showError = false;
				vm.is_valid_file = true;
				if (response && response.status && response.status >= 200 && response.status < 400) {
					if (response.data) {
						var data = response.data;
						vm.totalRows = data.totalRows;
						vm.failedRows = data.failedRows;
						vm.successRows = data.successRows;

						if (data.rowsInfo && data.rowsInfo.length > 0) {
							vm.importResults = data.rowsInfo;
						} else {
							vm.importResults = [];
						}
						vm.showResults = true;
					}
				} else if (response.status == 400) {
					vm.importResults = [];
					vm.errorMessage = response.data.error;
					vm.is_valid_file = (typeof response.data['is_valid_file'] !== 'undefined' &&
											response.data['is_valid_file']);
					vm.showError = true;
				}  else {
					vm.totalProjects = 0;
					vm.failedRows = 0;
					vm.successRows = 0;
					vm.showError = true;
					vm.importResults = [];
					vm.errorMessage = 'Something went wrong. Please try again later.';
					vm.showResults = true;
				}
			});
		}

		init();

		function init() {
			if (!$rootScope.authz.isAdmin()) {
				$window.location.href = $window.location.protocol + '//' + $window.location.host + '/application/f/home.html#/unauthorized';
			}
		}

		function downloadTemplateFile() {
			importProjectsService.getProjectsTemplate();
		}
	}
})();
